const _ = require('underscore');
const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    defaults: {
        'app_id': 'balus-local',
        'app_env': 'localhost',
        'firebase_env': 'localhost',
        'current_version': 'default-version',
        'current_version_date': null,
        'code_version': null,
        'host': 'localhost',
        'url': 'http://localhost',
        'ga_track_domain': null,
        'ga_track_id': null,
        'rollbar_env': null,
        'rollbar_token': null,
        'staging_groups': {}
    },

    getGATrackDomain: function() {
        return this.get('ga_track_domain');
    },

    getGATrackID: function() {
        return this.get('ga_track_id');
    },

    getRollbarEnv: function() {
        return this.get('rollbar_env');
    },

    getRollbarToken: function() {
        return this.get('rollbar_token');
    },

    getAppID: function() {
        return this.get('app_id');
    },

    getAppEnv: function() {
        return this.get('app_env');
    },

    getFirebaseEnv: function() {
        return this.get('firebase_env');
    },

    getCodeVersion: function() {
        return this.get('code_version');
    },

    _getPreviewGroups: function() {
        return this.get('staging_groups');
    },

    isProduction: function(groupID) {
        if(this.getAppEnv() != 'production') {
            return false;
        }
        if(groupID && _.has(this._getPreviewGroups(), groupID.toString())) {
            return false;
        }
        return true;
    },

    isLocalhost: function() {
        return this.getAppEnv() == 'localhost';
    }
});



// WEBPACK FOOTER //
// ./common/domain/entity/app-info.js